import { createClient } from '@supabase/supabase-js';

// Create Supabase client
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export async function fetchAvailableTrackingNumbers() {
  try {
    const { data, error } = await supabase.rpc('get_china_tracking_details');

    if (error) {
      console.error('Error fetching tracking numbers:', error);
      return { success: false, error: error.message };
    }

    return { success: true, data };
  } catch (err) {
    console.error('Error in fetchAvailableTrackingNumbers:', err);
    return { success: false, error: err instanceof Error ? err.message : 'Unknown error' };
  }
}